import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize } from 'rxjs';
import { BusyService } from '../services/busy.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(
    private loaderService: BusyService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    this.loaderService.busy();

    return next.handle(request).pipe(
      finalize(() => this.loaderService.idle()),
    );
  }
}
